const mainCart = document.getElementById('main-cart')

const upsellItems = mainCart.querySelectorAll('.upsell-item-wrapper')

const numberWithCommas = (x) => {
  return x
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const refreshCartData = (data) => {
  const realCartItems = data.items
  //update total price
  const totalPriceSelector = document.getElementById('cart-total-price')
  document
    .querySelectorAll('.cart-count')
    .forEach((cartCount) => (cartCount.textContent = data.item_count))
  let totalPrice = data.total_price / 100.0
  totalPriceSelector.innerText = `${currency}${numberWithCommas(totalPrice)}`

  //update line item prices
  let cartItems = document.createElement('div')
  cartItems.classList.add('cart-items__container')
  realCartItems.forEach((cartItem) => {
    let clonedElementMobile = document
      .querySelector('.empty-cart-item > .cart-item.mobile')
      .cloneNode(true)
    let clonedElementDesktop = document
      .querySelector('.empty-cart-item > .cart-item.desktop')
      .cloneNode(true)

    clonedElementMobile.setAttribute('data-variant-id', cartItem.variant_id)
    clonedElementDesktop.setAttribute('data-variant-id', cartItem.variant_id)

    //update title (if new product)
    clonedElementMobile.querySelector('.cart-item__title').innerText =
      cartItem.title
    clonedElementDesktop.querySelector('.cart-item__title a').innerText =
      cartItem.title
    clonedElementMobile
      .querySelector('.cart-item__title')
      .setAttribute('href', cartItem.url)
    clonedElementDesktop
      .querySelector('.cart-item__title a')
      .setAttribute('href', cartItem.url)

    //update qty
    clonedElementMobile.querySelector('input[name="quantity"]').value =
      cartItem.quantity
    clonedElementDesktop.querySelector('input[name="quantity"]').value =
      cartItem.quantity

    //update img
    clonedElementMobile
      .querySelector('.cart-item-image')
      .setAttribute('src', cartItem.featured_image.url)
    clonedElementDesktop
      .querySelector('.cart-item__image img')
      .setAttribute('src', cartItem.featured_image.url)

    //update price
    let lineItemPrice = cartItem.final_line_price / 100.0
    let unitPrice = cartItem.final_price / 100.0

    //each price
    const unitPriceSelector = clonedElementDesktop.querySelector(
      '.cart-item__unit-price'
    )
    unitPriceSelector.innerText = `${currency}${numberWithCommas(unitPrice)}`

    //total per item
    const priceSelectorMobile = clonedElementMobile.querySelector(
      '.cart-item-subtotal'
    )
    const priceSelectorDesktop = clonedElementDesktop.querySelector(
      '.cart-item__totals span'
    )

    priceSelectorMobile.innerText = `${currency}${numberWithCommas(
      lineItemPrice
    )}`
    priceSelectorDesktop.innerText = `${currency}${numberWithCommas(
      lineItemPrice
    )}`

    cartItems.appendChild(clonedElementMobile)
    cartItems.appendChild(clonedElementDesktop)
  })
  mainCart.querySelector('.cart-items__container').innerHTML =
    cartItems.innerHTML
  //attach event listeners
  mainCart
    .querySelectorAll('.cart-items__container .cart-item')
    .forEach((cartItem, idx) => {
      const variantId = cartItem.getAttribute('data-variant-id')
      cartItem.querySelector('input[name="quantity"]').value =
        realCartItems.find(
          (el) => el.variant_id === parseInt(variantId)
        ).quantity

      manageState(cartItem)
    })

  // upsell item handlers
  upsellItems.forEach((upsellItem) => {
    const upsellItemId = upsellItem?.querySelector(
      'form input[name="id"]'
    )?.value
    let upsellInCart = realCartItems.find(
      (element) => element.variant_id === parseInt(upsellItemId)
    )
    if (upsellInCart && upsellItem) upsellItem.style.display = 'none'
    else if (!upsellInCart && upsellItem) upsellItem.style.display = 'grid'
  })

  // free shipping
  const amountLeft = freeShippingThreshold - totalPrice

  mainCart.querySelector('.free-shipping-left > #amount-left').innerText =
    currency + amountLeft.toFixed(2)
  mainCart
    .querySelector('.free-shipping-left')
    .setAttribute(
      'data-percentage',
      freeShippingThreshold <= totalPrice
        ? 100
        : 100 * (amountLeft / freeShippingThreshold).toFixed(2)
    )

  if (freeShippingThreshold <= totalPrice) {
    mainCart.querySelector('.free-shipping-left').style.display = 'none'
    mainCart.querySelector('.free-shipping-qualified').style.display = 'block'
  } else {
    mainCart.querySelector('.free-shipping-left').style.display = 'block'
    mainCart.querySelector('.free-shipping-qualified').style.display = 'none'
  }

  document.body.classList.add('active', 'addtocart')
  window.setTimeout(
    () => document.body.classList.remove('active', 'addtocart'),
    2000
  )
}

const fetchCart = () => {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      refreshCartData(data)
    })
}

const options = {
  attributes: true,
}

function callback(mutationList, observer) {
  mutationList.forEach(function (mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      // handle class change
      fetchCart()
    }
  })
}

const observer = new MutationObserver(callback)
observer.observe(mainCart, options)

// cart updates

const changeCartItem = (item) => {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item),
  })
    .then((response) => {
      return response.json()
    })
    .then(function (data) {
      // This is the JSON from our response
      refreshCartData(data)
    })
    .catch((error) => {
      console.error('Error:', error)
    })
}

const manageState = (cartItem) => {
  const id = cartItem.getAttribute('data-variant-id')
  const quantityInput = cartItem.querySelector('input[name="quantity"]')
  const deleteItem = cartItem.querySelector(
    '.cart-item-delete, .cart-item__remove'
  )

  let quantity = parseInt(quantityInput.value)

  const qtyPlus = cartItem.querySelector('.quantity button[name="plus"]')
  const qtyMinus = cartItem.querySelector('.quantity button[name="minus"]')

  qtyPlus.addEventListener('click', function () {
    quantity = quantity + 1
    quantityInput.value = quantity

    changeCartItem({
      id: id,
      quantity: quantity,
    })
  })

  qtyMinus.addEventListener('click', function () {
    quantity = quantity - 1
    quantityInput.value = quantity
    changeCartItem({
      id: id,
      quantity: quantity,
    })
  })

  deleteItem.addEventListener('click', function () {
    changeCartItem({
      id: id,
      quantity: 0,
    })
    cartItem.remove()
  })
}

mainCart.querySelectorAll('.cart-item').forEach((cartItem) => {
  manageState(cartItem)
})

fetchCart()
